import Link from '../../views/TranslatedCodeRequest';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  username: state.shift.auth.username,
  projectList: state.shift.assessment.RepositoryNameList,
  refrenceidList: state.shift.assessment.refrenceidList,
  clientname: state.shift.assessment.clientname,
  opportunity_num:state.shift.assessment.opportunity_num,
  translationRate:state.shift.assessment.translationRate,
  reference_id: state.shift.assessment.reference_id,
  quotation_id: state.shift.assessment.quotation_id,
  reponame: state.shift.assessment.reponame,
  srclang: state.shift.assessment.srclang,
  tgtlang: state.shift.assessment.tgtlang,
  description: state.shift.assessment.description,
  popwindow: state.shift.status.popwindow,
  isOrderConfirmed:state.shift.assessment.isOrderConfirmed
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {

    handleOrderconfirmed: event => {//alert(event.target.checked)
      dispatch(actions.changeorderconfirmed(event.target.checked))
    },


    transSubmitHandler: (reponame, reference_id, quotation_id,isOrderConfirmed) => {
      var isOrderConfirmed = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['isOrderConfirmed'];

     const quotationid = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['quotation_id'];

      if(isOrderConfirmed){
        dispatch(actions.getQuotbypo(JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['quotation_id']))//.then(() =>{

         dispatch( actions.saveOrderRequest(reponame, reference_id,quotationid,true)

          );

      }else{

      }

  // if(isOrderConfirmed){
  //     dispatch(
  //       //actions.saveOrderRequest(reponame, reference_id, quotation_id,isOrderConfirmed)
  //       actions.saveapprovetranslation(reponame, reference_id, quotation_id)
  //     );}
    },


    getReferenceList: event => {
      dispatch(actions.getreferenceidlist({ value: event.target.value }.value));
    },

    getinfobyreferenceid: event => {
      dispatch(
        actions.getinfobyreferenceid({ value: event.target.value }.value)
      );
    },

    clickBackHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/shift`));
    },
    downloadHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/shift`));
    }
  };
};

const TranslatedCodeRequest = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default TranslatedCodeRequest;



// WEBPACK FOOTER //
// ./src/components/container/TranslatedCodeRequest/index.js